// @flow
import React, { Component, type Node } from 'react';
import createHydra from 'app/packages/createHydra';

export type ContentHeaderContextType = {
  isContentHeaderPresent: boolean,
  setIsContentHeaderPresent: (boolean) => void,
};

const {
  Provider,
  Consumer: ContentHeaderContextConsumer,
  useHook: useContentHeaderContext,
} = createHydra<ContentHeaderContextType>('ContentHeader');

export { ContentHeaderContextConsumer, useContentHeaderContext };

type Props = {|
  children: Node,
|};

type State = {|
  isContentHeaderPresent: boolean,
  setIsContentHeaderPresent: (boolean) => void,
|};

export default class ContentHeaderProvider extends Component<Props, State> {
  state = {
    isContentHeaderPresent: false,
    setIsContentHeaderPresent: (isContentHeaderPresent: boolean) => {
      this.setState({ isContentHeaderPresent });
    },
  };

  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>;
  }
}
